module.exports = __webpack_public_path__ + "img/top-blue.68879b17.svg";